import { registerTranslations } from "i18n";
import enEnterpriseAi from "./en/enterprise_ai.json";
import enEnterpriseArchive from "./en/enterprise_archive.json";
import enEnterpriseAuditlog from "./en/enterprise_auditlog.json";
import enEnterpriseAuthentication from "./en/enterprise_authentication.json";
import enEnterpriseCollections from "./en/enterprise_collections.json";
import enEnterpriseCommon from "./en/enterprise_common.json";
import enEnterpriseCustomization from "./en/enterprise_customization.json";
import enEnterpriseDataLake from "./en/enterprise_data_lake.json";
import enEnterpriseDataTiering from "./en/enterprise_data_tiering.json";
import enEnterpriseEntityAttributes from "./en/enterprise_entity_attributes.json";
import enEnterpriseForwarder from "./en/enterprise_forwarder.json";
import enEnterpriseIlluminate from "./en/enterprise_illuminate.json";
import enEnterpriseIntegrations from "./en/enterprise_integrations.json";
import enEnterpriseHealth from "./en/enterprise_health.json";
import enEnterpriseLicense from "./en/enterprise_license.json";
import enEnterpriseLookup from "./en/enterprise_lookup.json";
import enEnterpriseNavigation from "./en/enterprise_navigation.json";
import enEnterpriseReport from "./en/enterprise_report.json";
import enEnterpriseSearch from "./en/enterprise_search.json";
import enEnterpriseSecurity from "./en/enterprise_security.json";
import enEnterpriseSecurityApp from "./en/enterprise_security_app.json";
import enEnterpriseSecurityAssets from "./en/enterprise_security_assets.json";
import enEnterpriseSecurityEvents from "./en/enterprise_security_events.json";
import enEnterpriseSecurityInvestigations from "./en/enterprise_security_investigations.json";
import enEnterpriseSecuritySigma from "./en/enterprise_security_sigma.json";
import enEnterpriseServerErrors from "./en/enterprise_server_errors.json";
import enEnterpriseServerFields from "./en/enterprise_server_fields.json";
registerTranslations("enterprise_ai", enEnterpriseAi, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-ai" */
    "./de/enterprise_ai.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-ai" */
    "./it/enterprise_ai.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-ai" */
    "./zh-TW/enterprise_ai.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-ai" */
    "./ja/enterprise_ai.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-ai" */
    "./pl/enterprise_ai.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-ai" */
    "./es/enterprise_ai.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-ai" */
    "./fr/enterprise_ai.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-ai" */
    "./pt-BR/enterprise_ai.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-ai" */
    "./zh-CN/enterprise_ai.json"
  )
});
registerTranslations("enterprise_archive", enEnterpriseArchive, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-archive" */
    "./de/enterprise_archive.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-archive" */
    "./it/enterprise_archive.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-archive" */
    "./zh-TW/enterprise_archive.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-archive" */
    "./ja/enterprise_archive.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-archive" */
    "./pl/enterprise_archive.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-archive" */
    "./es/enterprise_archive.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-archive" */
    "./fr/enterprise_archive.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-archive" */
    "./pt-BR/enterprise_archive.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-archive" */
    "./zh-CN/enterprise_archive.json"
  )
});
registerTranslations("enterprise_auditlog", enEnterpriseAuditlog, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-auditlog" */
    "./de/enterprise_auditlog.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-auditlog" */
    "./it/enterprise_auditlog.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-auditlog" */
    "./zh-TW/enterprise_auditlog.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-auditlog" */
    "./ja/enterprise_auditlog.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-auditlog" */
    "./pl/enterprise_auditlog.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-auditlog" */
    "./es/enterprise_auditlog.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-auditlog" */
    "./fr/enterprise_auditlog.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-auditlog" */
    "./pt-BR/enterprise_auditlog.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-auditlog" */
    "./zh-CN/enterprise_auditlog.json"
  )
});
registerTranslations("enterprise_authentication", enEnterpriseAuthentication, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-authentication" */
    "./de/enterprise_authentication.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-authentication" */
    "./it/enterprise_authentication.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-authentication" */
    "./zh-TW/enterprise_authentication.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-authentication" */
    "./ja/enterprise_authentication.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-authentication" */
    "./pl/enterprise_authentication.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-authentication" */
    "./es/enterprise_authentication.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-authentication" */
    "./fr/enterprise_authentication.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-authentication" */
    "./pt-BR/enterprise_authentication.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-authentication" */
    "./zh-CN/enterprise_authentication.json"
  )
});
registerTranslations("enterprise_collections", enEnterpriseCollections, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-collections" */
    "./de/enterprise_collections.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-collections" */
    "./it/enterprise_collections.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-collections" */
    "./zh-TW/enterprise_collections.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-collections" */
    "./ja/enterprise_collections.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-collections" */
    "./pl/enterprise_collections.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-collections" */
    "./es/enterprise_collections.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-collections" */
    "./fr/enterprise_collections.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-collections" */
    "./pt-BR/enterprise_collections.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-collections" */
    "./zh-CN/enterprise_collections.json"
  )
});
registerTranslations("enterprise_common", enEnterpriseCommon, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-common" */
    "./de/enterprise_common.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-common" */
    "./it/enterprise_common.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-common" */
    "./zh-TW/enterprise_common.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-common" */
    "./ja/enterprise_common.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-common" */
    "./pl/enterprise_common.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-common" */
    "./es/enterprise_common.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-common" */
    "./fr/enterprise_common.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-common" */
    "./pt-BR/enterprise_common.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-common" */
    "./zh-CN/enterprise_common.json"
  )
});
registerTranslations("enterprise_customization", enEnterpriseCustomization, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-customization" */
    "./de/enterprise_customization.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-customization" */
    "./it/enterprise_customization.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-customization" */
    "./zh-TW/enterprise_customization.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-customization" */
    "./ja/enterprise_customization.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-customization" */
    "./pl/enterprise_customization.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-customization" */
    "./es/enterprise_customization.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-customization" */
    "./fr/enterprise_customization.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-customization" */
    "./pt-BR/enterprise_customization.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-customization" */
    "./zh-CN/enterprise_customization.json"
  )
});
registerTranslations("enterprise_data_lake", enEnterpriseDataLake, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-data-lake" */
    "./de/enterprise_data_lake.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-data-lake" */
    "./it/enterprise_data_lake.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-data-lake" */
    "./zh-TW/enterprise_data_lake.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-data-lake" */
    "./ja/enterprise_data_lake.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-data-lake" */
    "./pl/enterprise_data_lake.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-data-lake" */
    "./es/enterprise_data_lake.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-data-lake" */
    "./fr/enterprise_data_lake.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-data-lake" */
    "./pt-BR/enterprise_data_lake.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-data-lake" */
    "./zh-CN/enterprise_data_lake.json"
  )
});
registerTranslations("enterprise_data_tiering", enEnterpriseDataTiering, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-data-tiering" */
    "./de/enterprise_data_tiering.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-data-tiering" */
    "./it/enterprise_data_tiering.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-data-tiering" */
    "./zh-TW/enterprise_data_tiering.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-data-tiering" */
    "./ja/enterprise_data_tiering.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-data-tiering" */
    "./pl/enterprise_data_tiering.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-data-tiering" */
    "./es/enterprise_data_tiering.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-data-tiering" */
    "./fr/enterprise_data_tiering.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-data-tiering" */
    "./pt-BR/enterprise_data_tiering.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-data-tiering" */
    "./zh-CN/enterprise_data_tiering.json"
  )
});
registerTranslations("enterprise_entity_attributes", enEnterpriseEntityAttributes, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-entity-attributes" */
    "./de/enterprise_entity_attributes.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-entity-attributes" */
    "./it/enterprise_entity_attributes.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-entity-attributes" */
    "./zh-TW/enterprise_entity_attributes.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-entity-attributes" */
    "./ja/enterprise_entity_attributes.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-entity-attributes" */
    "./pl/enterprise_entity_attributes.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-entity-attributes" */
    "./es/enterprise_entity_attributes.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-entity-attributes" */
    "./fr/enterprise_entity_attributes.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-entity-attributes" */
    "./pt-BR/enterprise_entity_attributes.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-entity-attributes" */
    "./zh-CN/enterprise_entity_attributes.json"
  )
});
registerTranslations("enterprise_forwarder", enEnterpriseForwarder, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-forwarder" */
    "./de/enterprise_forwarder.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-forwarder" */
    "./it/enterprise_forwarder.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-forwarder" */
    "./zh-TW/enterprise_forwarder.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-forwarder" */
    "./ja/enterprise_forwarder.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-forwarder" */
    "./pl/enterprise_forwarder.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-forwarder" */
    "./es/enterprise_forwarder.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-forwarder" */
    "./fr/enterprise_forwarder.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-forwarder" */
    "./pt-BR/enterprise_forwarder.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-forwarder" */
    "./zh-CN/enterprise_forwarder.json"
  )
});
registerTranslations("enterprise_illuminate", enEnterpriseIlluminate, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-illuminate" */
    "./de/enterprise_illuminate.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-illuminate" */
    "./it/enterprise_illuminate.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-illuminate" */
    "./zh-TW/enterprise_illuminate.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-illuminate" */
    "./ja/enterprise_illuminate.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-illuminate" */
    "./pl/enterprise_illuminate.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-illuminate" */
    "./es/enterprise_illuminate.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-illuminate" */
    "./fr/enterprise_illuminate.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-illuminate" */
    "./pt-BR/enterprise_illuminate.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-illuminate" */
    "./zh-CN/enterprise_illuminate.json"
  )
});
registerTranslations("enterprise_integrations", enEnterpriseIntegrations, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-integrations" */
    "./de/enterprise_integrations.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-integrations" */
    "./it/enterprise_integrations.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-integrations" */
    "./zh-TW/enterprise_integrations.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-integrations" */
    "./ja/enterprise_integrations.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-integrations" */
    "./pl/enterprise_integrations.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-integrations" */
    "./es/enterprise_integrations.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-integrations" */
    "./fr/enterprise_integrations.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-integrations" */
    "./pt-BR/enterprise_integrations.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-integrations" */
    "./zh-CN/enterprise_integrations.json"
  )
});
registerTranslations("enterprise_license", enEnterpriseLicense, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-license" */
    "./de/enterprise_license.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-license" */
    "./it/enterprise_license.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-license" */
    "./zh-TW/enterprise_license.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-license" */
    "./ja/enterprise_license.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-license" */
    "./pl/enterprise_license.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-license" */
    "./es/enterprise_license.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-license" */
    "./fr/enterprise_license.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-license" */
    "./pt-BR/enterprise_license.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-license" */
    "./zh-CN/enterprise_license.json"
  )
});
registerTranslations("enterprise_lookup", enEnterpriseLookup, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-lookup" */
    "./de/enterprise_lookup.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-lookup" */
    "./it/enterprise_lookup.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-lookup" */
    "./zh-TW/enterprise_lookup.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-lookup" */
    "./ja/enterprise_lookup.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-lookup" */
    "./pl/enterprise_lookup.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-lookup" */
    "./es/enterprise_lookup.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-lookup" */
    "./fr/enterprise_lookup.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-lookup" */
    "./pt-BR/enterprise_lookup.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-lookup" */
    "./zh-CN/enterprise_lookup.json"
  )
});
registerTranslations("enterprise_navigation", enEnterpriseNavigation, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-navigation" */
    "./de/enterprise_navigation.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-navigation" */
    "./it/enterprise_navigation.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-navigation" */
    "./zh-TW/enterprise_navigation.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-navigation" */
    "./ja/enterprise_navigation.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-navigation" */
    "./pl/enterprise_navigation.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-navigation" */
    "./es/enterprise_navigation.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-navigation" */
    "./fr/enterprise_navigation.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-navigation" */
    "./pt-BR/enterprise_navigation.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-navigation" */
    "./zh-CN/enterprise_navigation.json"
  )
});
registerTranslations("enterprise_report", enEnterpriseReport, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-report" */
    "./de/enterprise_report.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-report" */
    "./it/enterprise_report.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-report" */
    "./zh-TW/enterprise_report.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-report" */
    "./ja/enterprise_report.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-report" */
    "./pl/enterprise_report.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-report" */
    "./es/enterprise_report.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-report" */
    "./fr/enterprise_report.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-report" */
    "./pt-BR/enterprise_report.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-report" */
    "./zh-CN/enterprise_report.json"
  )
});
registerTranslations("enterprise_search", enEnterpriseSearch, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-search" */
    "./de/enterprise_search.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-search" */
    "./it/enterprise_search.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-search" */
    "./zh-TW/enterprise_search.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-search" */
    "./ja/enterprise_search.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-search" */
    "./pl/enterprise_search.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-search" */
    "./es/enterprise_search.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-search" */
    "./fr/enterprise_search.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-search" */
    "./pt-BR/enterprise_search.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-search" */
    "./zh-CN/enterprise_search.json"
  )
});
registerTranslations("enterprise_security", enEnterpriseSecurity, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-security" */
    "./de/enterprise_security.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-security" */
    "./it/enterprise_security.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-security" */
    "./zh-TW/enterprise_security.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-security" */
    "./ja/enterprise_security.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-security" */
    "./pl/enterprise_security.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-security" */
    "./es/enterprise_security.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-security" */
    "./fr/enterprise_security.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-security" */
    "./pt-BR/enterprise_security.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-security" */
    "./zh-CN/enterprise_security.json"
  )
});
registerTranslations("enterprise_security_app", enEnterpriseSecurityApp, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-security-app" */
    "./de/enterprise_security_app.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-security-app" */
    "./it/enterprise_security_app.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-security-app" */
    "./zh-TW/enterprise_security_app.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-security-app" */
    "./ja/enterprise_security_app.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-security-app" */
    "./pl/enterprise_security_app.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-security-app" */
    "./es/enterprise_security_app.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-security-app" */
    "./fr/enterprise_security_app.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-security-app" */
    "./pt-BR/enterprise_security_app.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-security-app" */
    "./zh-CN/enterprise_security_app.json"
  )
});
registerTranslations("enterprise_security_assets", enEnterpriseSecurityAssets, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-security-assets" */
    "./de/enterprise_security_assets.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-security-assets" */
    "./it/enterprise_security_assets.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-security-assets" */
    "./zh-TW/enterprise_security_assets.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-security-assets" */
    "./ja/enterprise_security_assets.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-security-assets" */
    "./pl/enterprise_security_assets.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-security-assets" */
    "./es/enterprise_security_assets.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-security-assets" */
    "./fr/enterprise_security_assets.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-security-assets" */
    "./pt-BR/enterprise_security_assets.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-security-assets" */
    "./zh-CN/enterprise_security_assets.json"
  )
});
registerTranslations("enterprise_security_events", enEnterpriseSecurityEvents, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-security-events" */
    "./de/enterprise_security_events.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-security-events" */
    "./it/enterprise_security_events.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-security-events" */
    "./zh-TW/enterprise_security_events.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-security-events" */
    "./ja/enterprise_security_events.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-security-events" */
    "./pl/enterprise_security_events.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-security-events" */
    "./es/enterprise_security_events.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-security-events" */
    "./fr/enterprise_security_events.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-security-events" */
    "./pt-BR/enterprise_security_events.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-security-events" */
    "./zh-CN/enterprise_security_events.json"
  )
});
registerTranslations("enterprise_security_investigations", enEnterpriseSecurityInvestigations, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-security-investigations" */
    "./de/enterprise_security_investigations.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-security-investigations" */
    "./it/enterprise_security_investigations.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-security-investigations" */
    "./zh-TW/enterprise_security_investigations.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-security-investigations" */
    "./ja/enterprise_security_investigations.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-security-investigations" */
    "./pl/enterprise_security_investigations.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-security-investigations" */
    "./es/enterprise_security_investigations.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-security-investigations" */
    "./fr/enterprise_security_investigations.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-security-investigations" */
    "./pt-BR/enterprise_security_investigations.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-security-investigations" */
    "./zh-CN/enterprise_security_investigations.json"
  )
});
registerTranslations("enterprise_security_sigma", enEnterpriseSecuritySigma, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-security-sigma" */
    "./de/enterprise_security_sigma.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-security-sigma" */
    "./it/enterprise_security_sigma.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-security-sigma" */
    "./zh-TW/enterprise_security_sigma.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-security-sigma" */
    "./ja/enterprise_security_sigma.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-security-sigma" */
    "./pl/enterprise_security_sigma.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-security-sigma" */
    "./es/enterprise_security_sigma.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-security-sigma" */
    "./fr/enterprise_security_sigma.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-security-sigma" */
    "./pt-BR/enterprise_security_sigma.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-security-sigma" */
    "./zh-CN/enterprise_security_sigma.json"
  )
});
registerTranslations("enterprise_server_errors", enEnterpriseServerErrors, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-server-errors" */
    "./de/enterprise_server_errors.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-server-errors" */
    "./it/enterprise_server_errors.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-server-errors" */
    "./zh-TW/enterprise_server_errors.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-server-errors" */
    "./ja/enterprise_server_errors.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-server-errors" */
    "./pl/enterprise_server_errors.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-server-errors" */
    "./es/enterprise_server_errors.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-server-errors" */
    "./fr/enterprise_server_errors.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-server-errors" */
    "./pt-BR/enterprise_server_errors.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-server-errors" */
    "./zh-CN/enterprise_server_errors.json"
  )
});
registerTranslations("enterprise_server_fields", enEnterpriseServerFields, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-server-fields" */
    "./de/enterprise_server_fields.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-server-fields" */
    "./it/enterprise_server_fields.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-server-fields" */
    "./zh-TW/enterprise_server_fields.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-server-fields" */
    "./ja/enterprise_server_fields.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-server-fields" */
    "./pl/enterprise_server_fields.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-server-fields" */
    "./es/enterprise_server_fields.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-server-fields" */
    "./fr/enterprise_server_fields.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-server-fields" */
    "./pt-BR/enterprise_server_fields.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-server-fields" */
    "./zh-CN/enterprise_server_fields.json"
  )
});
registerTranslations("enterprise_health", enEnterpriseHealth, {
  de: () => import(
    /* webpackChunkName: "translations-de-enterprise-health" */
    "./de/enterprise_health.json"
  ),
  it: () => import(
    /* webpackChunkName: "translations-it-enterprise-health" */
    "./it/enterprise_health.json"
  ),
  "zh-TW": () => import(
    /* webpackChunkName: "translations-zh-tw-enterprise-health" */
    "./zh-TW/enterprise_health.json"
  ),
  ja: () => import(
    /* webpackChunkName: "translations-ja-enterprise-health" */
    "./ja/enterprise_health.json"
  ),
  pl: () => import(
    /* webpackChunkName: "translations-pl-enterprise-health" */
    "./pl/enterprise_health.json"
  ),
  es: () => import(
    /* webpackChunkName: "translations-es-enterprise-health" */
    "./es/enterprise_health.json"
  ),
  fr: () => import(
    /* webpackChunkName: "translations-fr-enterprise-health" */
    "./fr/enterprise_health.json"
  ),
  "pt-BR": () => import(
    /* webpackChunkName: "translations-pt-br-enterprise-health" */
    "./pt-BR/enterprise_health.json"
  ),
  "zh-CN": () => import(
    /* webpackChunkName: "translations-zh-cn-enterprise-health" */
    "./zh-CN/enterprise_health.json"
  )
});
